import React from "react";
import { Card, CardActionArea, Typography, Box } from "@mui/material";

const CardRadioGroup = ({ value, items = [], onChange, sx, itemSx }) => {
  return (
    <Card
      variant="outlined"
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "stretch",
        width: "100%",
        overflow: "hidden",
        ...sx,
      }}
    >
      {items.map((item, index) => {
        const isSelected = item.id === value;
        const isLast = index === items.length - 1;

        return (
          <React.Fragment key={item.id}>
            <CardActionArea
              onClick={() => onChange && onChange(item)}
              sx={(theme) => ({
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                flex: 1,
                py: 0.75,
                backgroundColor: isSelected
                  ? `${theme.palette.info.main}33`
                  : "transparent",
                color: isSelected
                  ? `${theme.palette.info.main} !important`
                  : "inherit",

                borderRadius: 0,
                ...itemSx,
              })}
            >
              <Typography
                variant="h6"
                sx={(theme) => ({
                  color: isSelected
                    ? `${theme.palette.info.main} !important`
                    : `${theme.palette.text.secondary} !important`,
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 1,
                  fontSize: "15px",
                })}
              >
                {item.label}
              </Typography>
            </CardActionArea>

            {!isLast && (
              <Box
                sx={{
                  alignSelf: "stretch",
                  width: "1px",
                  backgroundColor: "divider",
                }}
              />
            )}
          </React.Fragment>
        );
      })}
    </Card>
  );
};

export default CardRadioGroup;
